import { Box, Stack, Typography } from '@mui/material'
import labelStyles from '@/components/Settings/settingsRowLabelBlock.module.scss'

/**
 * Shared label column for settings `Paper` rows: small leading icon, 13px title, optional 13px description at 70% text opacity.
 *
 * @param {{
 *   Icon?: import('react').ComponentType<{ style?: React.CSSProperties, 'aria-hidden'?: boolean }>,
 *   title: string,
 *   description?: string,
 *   hideDescription?: boolean,
 *   titleAs?: import('@mui/material').TypographyProps['component'],
 * }} props
 */
export function SettingsRowLabelBlock({
  Icon,
  title,
  description,
  hideDescription = false,
  titleAs = 'h3',
}) {
  const showDescription = !hideDescription && description != null && description !== ''

  return (
    <Box className={labelStyles.labelRoot}>
      <Stack direction="row" alignItems="center" spacing={0} className={labelStyles.titleRow}>
        {Icon ? (
          <Box component="span" className={labelStyles.iconWrap} aria-hidden>
            <Icon />
          </Box>
        ) : null}
        <Typography component={titleAs} variant="subtitle2" className={labelStyles.title}>
          {title}
        </Typography>
      </Stack>
      {showDescription ? (
        <Typography variant="body2" component="p" className={labelStyles.description}>
          {description}
        </Typography>
      ) : null}
    </Box>
  )
}
